import { render, staticRenderFns } from "./ProjectModal.vue?vue&type=template&id=4d2b4634&"
import script from "./ProjectModal.vue?vue&type=script&lang=js&"
export * from "./ProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectModal.vue"
export default component.exports